import { IWysiwygSettings } from "shared";
import {
    IListComponent,
    ITemplateAutonumberComponent,
    ITemplateComponent,
    ITemplateLanguageComponent
} from "../types/template_service_types";
import { ComponentTypes } from "../const/componentTypes";

const componentFieldsMap: Record<ComponentTypes, string[]> = {
    [ComponentTypes.input]: ["type", "protect", "label", "label_en", "name", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup", "isNumber", "minNumber", "maxNumber", "minStringLength", "maxStringLength"],
    [ComponentTypes.text]: ["type", "protect", "label", "label_en", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "isRowGroup"],
    [ComponentTypes.dateInput]: ["type", "protect", "label", "label_en", "name", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup", "readonly", "isDefaultDate"],
    [ComponentTypes.select]: ["type", "protect", "label", "label_en", "name", "list", "list_en", "defaultValue", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup", "readonly"],
    [ComponentTypes.inputWithSelect]: ["type", "protect", "label", "label_en", "name", "list", "list_en", "defaultValue", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup", "readonly", "selectonly"],
    [ComponentTypes.money]: ["type", "protect", "label", "label_en", "name", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup", "minNumber", "maxNumber", "useEnValue"],
    [ComponentTypes.checkbox]: ["type", "protect", "label", "label_en", "name", "defaultValue", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "readonly", "isRowGroup"],
    [ComponentTypes.radio]: ["type", "protect", "label", "label_en", "name", "list", "list_en", "defaultValue", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "direction", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup", "readonly"],
    [ComponentTypes.multiline]: ["type", "protect", "label", "label_en", "name", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup"],
    [ComponentTypes.table]: ["type", "protect", "label", "label_en", "name", "drawHeader", "list", "list_en", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required"],
    [ComponentTypes.file]: ["type", "protect", "label", "label_en", "name", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "isRowGroup"],
    [ComponentTypes.hrPerson]: ["type", "protect", "label", "label_en", "fieldsList", "suffix", "limitToBusinessGroups", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "readonly"],
    [ComponentTypes.yandex]: ["type", "protect", "label", "label_en", "optionsList", "list", "defaultValue", "listBankDetails", "fieldsList", "suffix", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "readonly", "selectonly"],
    [ComponentTypes.legalYandex]: ["type", "protect", "label", "label_en", "optionsList", "list", "defaultValue", "listBankDetails", "listLegalBankDetails", "bgBlackList", "buBlackList", "countriesBlackList", "additionalCompanies", "bankDetailsFilter", "fieldsList", "suffix", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "readonly", "selectonly"],
    [ComponentTypes.counterparty]: ["type", "protect", "label", "label_en", "fieldsList", "suffix", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "required", "readonly", "selectonly"],
    [ComponentTypes.saveAndTicket]: ["type", "protect", "startrekQueue", "issueType", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "isRowGroup", "isProtected", "isDocPdf", "isDocRtf", "isTicketRtf", "isTicketPdf", "isDocPdfNopass", "isDocRtfNopass", "isTicketPdfNopass", "isTicketRtfNopass", "isDocAndTicketPdf", "isDocAndTicketRtf", "isTicketPdfRtfNopass", "isUploadFile"],
    [ComponentTypes.saveToExistingTicket]: ["type", "protect", "label", "label_en", "name", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "startrekQueueAttach", "startrekCommentTemplate", "startrekCommentTemplate_en", "isDocPdf", "isDocRtf", "isDocPdfNopass", "isDocRtfNopass", "isUploadFile", "isFullView"],
    [ComponentTypes.pdfPassword]: ["type", "protect", "label", "label_en", "name", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en"],
    [ComponentTypes.trackerIntegration]: ["type", "name", "startrekFields", "textWithVariables"],
    [ComponentTypes.iprocIntegration]: ["type", "protect", "label", "label_en", "startrekQueueIproc", "list", "list_en", "defaultValue", "additionalDefaultValue", "hideIprocStyle", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "isTemplate", "format", "ticketNum"],
    [ComponentTypes.externalForm]: ["type", "protect", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "wysiwyg_tooltip", "wysiwyg_tooltip_en"],
    [ComponentTypes.language]: ["type", "isLangEn"],
    [ComponentTypes.uuid]: ["type", "name"],
    [ComponentTypes.barcode]: ["type", "protect", "label", "label_en", "name", "barcodeType", "ratio", "visibilityParentName", "visibilityParentNegate", "visibilityParentValue", "tooltip", "tooltip_en", "useWysiwygTooltip", "wysiwyg_tooltip", "wysiwyg_tooltip_en", "isRowGroup", "required"],
    [ComponentTypes.autonumber]: ["type", "id"],
    [ComponentTypes.preview]: ["type"],
    [ComponentTypes.massDocGeneration]: ["type", "startrekQueue", "issueType", "format", "mergeDoc"]
};

export const stringToWysiwygSettings = (desc?: string | null): IWysiwygSettings => {
    let settings: IWysiwygSettings = {};

    if (desc) {
        try {
            settings = JSON.parse(desc);
        } catch (e) {
            console.error(e);
        }
    }

    return settings;

};

export const cleanupTemplateComponents = (components: ITemplateComponent[]) => {
    const updatedComponents: Partial<ITemplateComponent>[] = [];
    const externalFormComponent = components.find(c => c.type === ComponentTypes.externalForm);
    const languageComponent = components.find(c => c.type === ComponentTypes.language) as ITemplateLanguageComponent | undefined;
    const enLangEnabled = !!languageComponent && languageComponent.isLangEn;

    components.forEach((component) => {
        if (component.type === ComponentTypes.autonumber) {
            const autonumberComponent = component as ITemplateAutonumberComponent;
            updatedComponents.push({
                type: ComponentTypes.autonumber,
                id: autonumberComponent.autonumberId === undefined
                    ? undefined
                    : String(autonumberComponent.autonumberId)
            } as Partial<ITemplateAutonumberComponent>);
            return;
        }

        const updatedComponent = { ...component } as Partial<ITemplateComponent>;
        const updatedListComponent = updatedComponent as IListComponent;
        const fieldsMap = componentFieldsMap[component.type];
        // Чистим поля, которые не подходят типу компонента
        Object.keys(updatedComponent).forEach(field => {
            if (!fieldsMap.includes(field)) {
                // @ts-ignore
                delete updatedComponent[field];
            }
        });

        delete updatedComponent.id;

        if (!externalFormComponent) {
            delete updatedComponent.protect;
        }

        if (!enLangEnabled) {
            delete updatedComponent.tooltip_en;
            delete updatedComponent.label_en;
            delete updatedListComponent.list_en;
        }

        if (!updatedComponent.visibilityParentName) {
            delete updatedComponent.visibilityParentNegate;
            delete updatedComponent.visibilityParentValue;
        }

        // удалить пустые строки из списков
        // только если в обоих списках list и list_en значение пусто
        if (Array.isArray(updatedListComponent.list)) {

            let index = updatedListComponent.list.length - 1;

            // в обратном порядке, чтобы при удалении индекс не съехал
            while (index >= 0) {
                const item = updatedListComponent.list[index];
                const item_en = updatedListComponent.list_en ? updatedListComponent.list_en[index] : undefined;
                if ((item === null || item === undefined || item === "")
                    && (item_en === null || item_en === undefined || item_en === "")
                ) {
                    updatedListComponent.list.splice(index, 1);
                    updatedListComponent.list_en && updatedListComponent.list_en.splice(index, 1);
                }

                index -= 1;
            }
        }

        updatedComponents.push(updatedComponent);
    });

    return updatedComponents;
};

export const addTemplateComponentId = (components: Partial<ITemplateComponent>[]) => {
    return components.map((component: Partial<ITemplateComponent>, index: number) => {
        if (component.type === ComponentTypes.autonumber) {
            const persistedId = component.id;
            const autonumberId = persistedId === undefined || persistedId === null || persistedId === ""
                ? undefined
                : Number(persistedId);

            return {
                ...component,
                autonumberId: autonumberId !== undefined && Number.isFinite(autonumberId) ? autonumberId : undefined,
                id: index
            } as ITemplateAutonumberComponent;
        }

        return { ...component, id: index } as ITemplateComponent;
    });
};
